var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeOwnerLogoTh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 350,
    viewBox: "0 0 426 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6471_7876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.257 57.8511H263.224C258.431 57.8511 254.546 61.7362 254.546 66.5288V95.4544C254.546 100.247 258.431 104.132 263.224 104.132H289.257C294.049 104.132 297.934 100.247 297.934 95.4544V66.5288C297.934 61.7362 294.049 57.8511 289.257 57.8511Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.785 57.8511H329.752C324.959 57.8511 321.074 61.7362 321.074 66.5288V95.4544C321.074 100.247 324.959 104.132 329.752 104.132H355.785C360.578 104.132 364.463 100.247 364.463 95.4544V66.5288C364.463 61.7362 360.578 57.8511 355.785 57.8511Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.785 121.488H329.752C324.959 121.488 321.074 125.373 321.074 130.165V159.091C321.074 163.884 324.959 167.769 329.752 167.769H355.785C360.578 167.769 364.463 163.884 364.463 159.091V130.165C364.463 125.373 360.578 121.488 355.785 121.488Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.793 188.017H289.256C294.049 188.017 297.933 191.902 297.933 196.694V225.62C297.933 230.413 294.049 234.298 289.256 234.298H274.793V188.017Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.785 188.017H329.752C324.959 188.017 321.074 191.902 321.074 196.694V225.62C321.074 230.412 324.959 234.298 329.752 234.298H355.785C360.578 234.298 364.463 230.412 364.463 225.62V196.694C364.463 191.902 360.578 188.017 355.785 188.017Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 306.811V191.069C11.5703 182.555 16.0121 174.218 18.233 171.114C39.9975 149.385 88.5906 102.467 108.845 88.6312C129.099 74.7952 144.823 82.8664 150.153 88.6312C178.58 112.578 236.768 162.6 242.098 171.114C247.428 179.628 248.76 187.965 248.76 191.069V306.811C243.43 329.162 226.107 335.635 218.112 336.078C167.476 337.854 61.1404 340.336 40.8858 336.078C20.6315 331.823 12.9028 314.795 11.5703 306.811Z",
    stroke: "#A200FF",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.735 176.446H107.024C97.4392 176.446 89.6689 184.217 89.6689 193.802V228.512C89.6689 238.098 97.4392 245.868 107.024 245.868H141.735C151.32 245.868 159.09 238.098 159.09 228.512V193.802C159.09 184.217 151.32 176.446 141.735 176.446Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.017 83.8843L221.281 111.364C220.799 90.6335 219.835 47.438 219.835 40.4959C219.835 33.5537 223.691 30.8541 225.62 30.3719H386.157C393.099 30.3719 394.835 40.9781 394.835 46.281V303.719C394.835 310.661 388.086 312.397 384.711 312.397H276.24C278.554 321.653 270.455 337.467 266.116 344.215H384.711C415.95 340.744 424.724 315.772 425.207 303.719V33.2645C425.207 8.96694 400.137 0.964186 387.603 0H225.62C203.636 0 191.391 22.1763 188.017 33.2645V83.8843Z",
    fill: "#A200FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.863 121.488C253.513 122.765 254.016 127.888 254.546 131.612C267.245 139.272 272.562 159.789 274.149 167.769H291.611C296.69 167.769 297.96 161.385 297.96 158.194V129.467C297.96 124.36 293.728 122.02 291.611 121.488H259.863Z",
    fill: "#A200FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6471_7876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425.207,
    height: 350,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOwnerLogoTh);
export default __webpack_public_path__ + "static/media/HomeOwnerLogo_TH.c80e9f142c061b2aef6815298f8fc2ad.svg";
export { ForwardRef as ReactComponent };